// Impressum.tsx
import React from "react";
import "./Impressum.css";
import SEOHead from "../../seo/SEOHead";
import { seoConfig } from "../../seo/seoConfig";
import { generateBreadcrumbs } from "../../seo/structuredData";

const Impressum: React.FC = () => {
  return (
    <main className="impressum">
      <SEOHead
        {...seoConfig.impressum}
        structuredData={generateBreadcrumbs([
          { name: 'Home', url: 'https://www.styror.com/' },
          { name: 'Impressum', url: 'https://www.styror.com/impressum' },
        ])}
      />
      <div className="container">
        <h1 className="impressum__title">Impressum – StyroR Recycling Management UG</h1>

        <section className="impressum__section">
          <h2>Über StyroR</h2>
          <p>
            Die StyroR – Styropor Recycling Management und Beratung UG ist ein in Hamburg
            ansässiges Unternehmen, das sich auf die professionelle Entsorgung und Verwertung
            von expandiertem Polystyrol (EPS), extrudiertem Polystyrol (XPS) und
            HBCD-belastetem Dämmmaterial spezialisiert hat. Mit einem Standort in Hamburg
            bieten wir Unternehmen aus der Bau-, Abbruch- und Entsorgungsbranche eine
            zuverlässige und umweltgerechte Lösung für die Styropor-Entsorgung.
            Als eingetragene Gesellschaft im Handelsregister des Amtsgerichts Hamburg
            stehen wir für Transparenz, Verantwortung und nachhaltiges Wirtschaften.
            Unser Leistungsspektrum umfasst die Abholung, Volumenreduzierung und Verwertung
            sämtlicher EPS-Materialien, einschließlich verschmutzter und HBCD-belasteter
            Dämmstoffe. Durch ein Netzwerk zertifizierter Partner-Fachbetriebe gewährleisten
            wir eine lückenlose und gesetzeskonforme Entsorgungskette.
            Wir arbeiten eng mit Unternehmen aus der Bau-, Abbruch- und Logistikbranche
            zusammen und bieten maßgeschneiderte Entsorgungskonzepte für jede Anforderung.
            Weitere Informationen zu unserem Recycling-Prozess, unseren Leistungen und
            den Möglichkeiten einer Zusammenarbeit finden Sie auf den übrigen Seiten
            dieser Website oder kontaktieren Sie uns direkt per Telefon, E-Mail
            oder über unser Kontaktformular. Wir freuen uns auf Ihre Anfrage und
            beraten Sie gerne unverbindlich.
          </p>
        </section>

        <section className="impressum__section">
          <h2>Unternehmensdetails</h2>
          <p>
            <strong>
              StyroR – Styropor Recycling Management und Beratung UG
            </strong>
            <br />
            Vertretungsberechtigter Geschäftsführer: André Mangold
          </p>
          <p>
            Telefon: <a href="tel:+4915903782712">+49 (0)1590 - 37 82 712</a>
            <br />
            E-Mail: <a href="mailto:info@StyroR.de">info@styror.com</a>
            <br />
            Internet: <a href="http://www.StyroR.de">www.styror.com</a>
          </p>
        </section>

        <section className="impressum__section">
          <h2>Standort</h2>
          <p>
            StyroR ist mit einem Standort in Hamburg vertreten. Dieser Standort steht
            für die Annahme und Verarbeitung von Styropor und EPS-Materialien zur Verfügung
            und ist für Anlieferungen nach vorheriger Terminvereinbarung zugänglich.
            Unser Team vor Ort unterstützt Sie bei der Übergabe und beantwortet
            Ihre Fragen rund um die fachgerechte Entsorgung und Verwertung.
          </p>
          <p>Rennbahnstraße 2, 22111 Hamburg</p>
        </section>

        <section className="impressum__section">
          <h2>Sitz der Gesellschaft</h2>
          <p>Hamburg</p>
        </section>

        <section className="impressum__section">
          <h2>Handelsregister</h2>
          <p>
            HRB 171592
            <br />
            Amtsgericht Hamburg
          </p>
        </section>

        <section className="impressum__section">
          <h2>Redaktionell Verantwortlich</h2>
          <p>André Mangold</p>
        </section>

        <section className="impressum__section">
          <h2>Haftungsausschluss</h2>
          <p>
            Alle auf dieser Website enthaltenen Angaben und Informationen sind
            kostenlos und dienen der allgemeinen Information. Sie stellen unter
            keinen Umständen eine rechtliche oder andere Beratung dar. Wenn Sie
            eine Frage zu einem bestimmten Problem oder zu den Angaben auf
            dieser Website haben, wenden Sie sich bitte an uns. Wir bemühen uns,
            alle Inhalte dieser Website laufend zu aktualisieren. Gleichwohl
            können wir keine Garantie oder Haftung für die Vollständigkeit und
            jederzeitige inhaltliche Richtigkeit übernehmen. Sofern diese
            Website Links zu anderen Sites ermöglicht, handelt es sich um
            Verweise auf Inhalte anderer Betreiber, auf die der redaktionell
            Verantwortliche keinerlei Einfluss hat. Sie wurden lediglich bei der
            ersten Aufnahme auf rechtswidrige Inhalte überprüft. Eine
            Verantwortung bzw. Haftung hierfür kann in keinem Fall übernommen
            werden.
          </p>
        </section>

        <section className="impressum__section">
          <h2>Einverständniserklärung</h2>
          <p>
            Durch die Nutzung dieser Website erteilen Sie dem redaktionell
            Verantwortlichen die ausdrückliche Erlaubnis, Ihre personenbezogenen
            Daten zu erfassen und für statistische Zwecke, auch
            grenzüberschreitend, zu nutzen. Um die Navigation auf dieser Website
            zu erleichtern, können Cookies eingesetzt werden. Mit der Nutzung
            dieser Website erteilen Sie die ausdrückliche Erlaubnis, über die
            Cookies Ihr Nutzerverhalten für statistische Zwecke zu speichern und
            zu nutzen.
          </p>
        </section>

        <section className="impressum__section">
          <h2>Nutzungsbedingungen</h2>
          <p>
            Durch den Besuch dieser Internetseite entsteht kein
            Rechtsverhältnis. Der Inhalt dieser Seite stellt keine Beratung und
            kein Angebot auf Auftrag dar. Der Inhalt dieser Seite darf nur für
            persönliche Zwecke verwendet werden und unterliegt dem Verbot der
            Vervielfältigung. Die inhaltliche Verbreitung und Vervielfältigung
            bedarf der Zustimmung des Urhebers, dem redaktionell
            Verantwortlichen.
          </p>
        </section>
      </div>
    </main>
  );
};

export default Impressum;
